import React from "react";
import { Link } from "react-router-dom";
// import { Container } from "react-bootstrap";
// import { Nav } from "react-bootstrap";
// import { Navbar, NavDropdown } from "react-bootstrap";
import "./header.css";
import { CgMathDivide } from "react-icons/cg";
import { BsEnvelopeOpen } from "react-icons/bs";
import { FaEnvelopeOpenText, FaRegUser, FaPowerOff } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../redux/Actions/Actions";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";

import { DropdownSubmenu, NavDropdownMenu } from "react-bootstrap-submenu";
import logo from "../../assests/images/DraftlOGO.png";

import Container from "react-bootstrap/Container";

import "react-bootstrap-submenu/dist/index.css";

const Header = () => {
  const state = useSelector((state) => state);
  const { auth, sidebar } = state;
  let navigate = useNavigate();
  const dispatch = useDispatch();
  function Logout() {
    dispatch({
      type: Actions.LOGOUT,
    });
    sessionStorage.clear();
    navigate("/login");
  }
  function ClearGame() {
    dispatch({
      type: Actions.CLEAR_GAME,
    });

    //window.open("_blank");
  }
  return (
    <div id="header-main">
      <Navbar collapseOnSelect bg="dark" variant="dark">
        <Container>
          <Navbar.Brand onClick={ClearGame}>
            <Link to="/Home" style={{ textDecoration: "none" }}>
              {/* <span className="logo1">Bett</span>
              <span className="logo2">Gaming</span> */}
              <img
                src={logo}
                style={{
                  width: "auto",
                  height: "44px",
                  cursor: "pointer",
                }}
                // className="d-inline-block align-top"
                alt="BettDraft"
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav2" />
          <Navbar.Collapse id="responsive-navbar-nav2">
            <Nav className="me-auto"> </Nav>
            {!auth.isAuthenticated && (
              <Nav>
                <Nav.Link
                  eventKey={2}
                  className="login-btn"
                  onClick={() => {
                    navigate("/login");
                  }}
                >
                  Log In
                </Nav.Link>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {auth.isAuthenticated && (
        <Navbar
          collapseOnSelect
          expand="lg"
          className="navbar-custom new-navbar custom-navbarnav"
        >
          <Container>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
              <Nav className="mr-auto">
                <Nav.Link
                  onClick={() => {
                    navigate("/Home");
                  }}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  onClick={() => {
                    navigate("/UserList");
                  }}
                >
                  Users
                </Nav.Link>

                <Nav.Link
                  onClick={() => {
                    navigate("/Banner");
                  }}
                >
                  Banner
                </Nav.Link>
                

                <Nav.Link
                  onClick={() => {
                    navigate("/MarketingPopup");
                  }}
                >
                  Marketing
                </Nav.Link>

                {/* <Nav.Link
                  onClick={() => {
                    navigate("/bonus");
                  }}
                >
                  Bonus
                </Nav.Link> */}
                <NavDropdownMenu title="Bonus" id="collasible-nav-dropdown">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/bonus");
                    }}
                  >
                   Bonus
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/bulkBonus");
                    }}
                  >
                   Bulk Upload Bonus
                  </NavDropdown.Item>
                 
                </NavDropdownMenu>


                {/* <Nav.Link
                  onClick={() => {
                    navigate("/campaign");
                  }}
                >
                  Campaign
                </Nav.Link> */}

                

                <Nav.Link
                  onClick={() => {
                    navigate("/PromoList");
                  }}
                >
                  Promo Code
                </Nav.Link>
                <NavDropdownMenu title="Coupon Menu" id="collasible-nav-dropdown">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/campaign");
                    }}
                  >
                   Campaign
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/coupon");
                    }}
                  >
                   Coupon
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/tracking");
                    }}
                  >
                   Tracking
                  </NavDropdown.Item>
                </NavDropdownMenu>


                
                <NavDropdownMenu title="Clients" id="collasible-nav-dropdown">
                  <DropdownSubmenu href="#action/3.7" title="Users">
                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/UserList");
                      }}
                    >
                      User List
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/UserBlockList");
                      }}
                    >
                      User Block List
                    </NavDropdown.Item>

                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/ActionList");
                      }}
                    >
                      Action List
                    </NavDropdown.Item>
                    <NavDropdown.Item href="#action/8.1">
                      Coonnected users
                    </NavDropdown.Item>
                    <NavDropdown.Item
                      onClick={() => {
                        navigate("/AccessList");
                      }}
                    >
                      Access list
                    </NavDropdown.Item>
                  </DropdownSubmenu>

                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/Staff");
                    }}
                  >
                    Staff
                  </NavDropdown.Item>
                </NavDropdownMenu>

                <NavDropdownMenu title="Tranfers" id="collasible-nav-dropdown">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/TransferSummary");
                    }}
                  >
                    Transfer Summary
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/TransferDetails");
                    }}
                  >
                    Transfer Details
                  </NavDropdown.Item>

                  {/* <NavDropdown.Item
                    onClick={() => {
                      navigate("/TransactionsDetail");
                    }}
                  >
                 Transactions Detail
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/TransactionsSummary");
                    }}
                  >
                Transactions Summary
                  </NavDropdown.Item> */}
                </NavDropdownMenu>

                <NavDropdownMenu title="Bets" id="collasible-nav-dropdown">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/Bets");
                    }}
                  >
                    BETS
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item
                    onClick={() => {
                      navigate("/CancelledBets");
                    }}
                  >
                    CANCELLED BETS
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/VoidBets");
                    }}
                  >
                    VOID BETS
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/ResettledBets");
                    }}
                  >
                    RESETTLED BETS
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/BetsResult");
                    }}
                  >
                    BETS RESULT
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/LiveBettingDetails");
                    }}
                  >
                    Live Betting Details
                  </NavDropdown.Item>

                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/LiveBettingReport");
                    }}
                  >
                    Live Betting Report
                  </NavDropdown.Item> */}

                </NavDropdownMenu>

                {/* <NavDropdownMenu title="Results">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/ResultsSummary");
                    }}
                  >
                    Results Summary
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/ResultsDetail");
                    }}
                  >
                    Results Detail
                  </NavDropdown.Item>
                </NavDropdownMenu> */}

                <NavDropdownMenu title="Sport">
                  {/* <NavDropdown.Item
                    onClick={() => {
                      navigate("/SportsLiability");
                    }}
                  >
                    Sports Liability
                  </NavDropdown.Item> */}
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/SportOperator");
                    }}
                  >
                    Sport Operator Reporting
                  </NavDropdown.Item>
                </NavDropdownMenu>
                <Nav.Link
                  onClick={() => {
                    navigate("/promo");
                  }}
                >
                  Promotion
                </Nav.Link>
                {/* <NavDropdownMenu title="Casino">
                <NavDropdown.Item
                    onClick={() => {
                      navigate("/provider");
                    }}
                  >
                  Provider
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/menu");
                    }}
                  >
                   Menu
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/featureGames");
                    }}
                  >
                   Feature Games
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/coinPackage");
                    }}
                  >
                   Coin Package 
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/games");
                    }}
                  >
                   Games
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/promo");
                    }}
                  >
                   Promo
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/redemption");
                    }}
                  >
                   Redemption
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/redemptionClaims");
                    }}
                  >
                   Redemption Claim
                  </NavDropdown.Item>
                  
                </NavDropdownMenu> */}
                <NavDropdownMenu title="Payments">
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/Payments");
                    }}
                  >
                    Payments
                  </NavDropdown.Item>
                  <NavDropdown.Item
                    onClick={() => {
                      navigate("/deposit");
                    }}
                  >
                    Deposit
                  </NavDropdown.Item>
                   
                </NavDropdownMenu>
                <Nav.Link
                  onClick={() => {
                    navigate("/offers");
                  }}
                >
                  Offers
                </Nav.Link>

                <Nav.Link className="last-link" onClick={Logout}>
                  QUIT
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      )}
    </div>
  );
};

export default Header;
